import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UserManagementService } from 'src/app/user-management/user-management.service';
@Component({
  selector: 'app-physical-credential-removed',
  templateUrl: './physical-credential-removed.component.html',
  styleUrls: ['./physical-credential-removed.component.scss'],
})
export class PhysicalCredentialRemovedComponent {
  stepper = 0;
  userDetail: any;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<PhysicalCredentialRemovedComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private translate: TranslateService
  ) {
    this.stepper = data?.stepper;
    this.userDetail = data?.userDetail;
  }
  /**
   * @description close modal popup
   * @returns void
   */
  closeDialog() {
    this.dialogRef?.close();
  }

  /**
   * @description parent function that will hold state of stepper from child
   * @returns void
   */
  changeStepper(event: any) {
    this.stepper = event;
  }

  /**
   * @description parent function that will be triggered from child component to delete the user
   * @returns void
   */
  deleteUserEmitter() {
    this.userManagementService
      .deleteUser(this.userDetail?.userId, this.userDetail?.siteId)
      .subscribe({
        next: (res: any) => {
          this.notificationService.showSuccess(
            this.commonService.stringInterPolation(
              this.translate.instant('SUCCESSFULLY_DELETED'),
              this.translate.instant('USER')
            )
          ); // default app-user-access-details-default should be
          this.dialogRef?.close(true); // get updated list from server and update redux state in user-list
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
  }
}
